import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,isFunction } from '../../../../utils/utils';
import { TRIP_ACTIONS } from '../../../../store/constants';
import { connect } from "react-redux";
import JourneyTripTimelineAction from '../../../components/journey/JourneyTripTimelineActionDialog';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding: "16px 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
    justifyContent:'center'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  sep:{
    width:24
  },
  actionButton:{
    width: '100%',
    paddingTop:16,
    paddingBottom:16,
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#00875a',
    fontWeight: 600,
    borderRadius: 8,
    fontSize:14,
    border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  viewBill:{
    width: '100%',
    paddingTop:16,
    paddingBottom:16,
    backgroundColor: '#0033cc',
    textTransform: 'capitalize',
    color: '#fff',
    fontWeight: 600,
    borderRadius: 8,
    fontSize:14,
    border: 'solid 0px #0033cc',
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  }
}));
const JourneyTripActionCard = ({
  selectedTrip,
  updateJourney,
  journey,
}) => {
  const classes = useStyles();
  let history = useHistory();
  const [tripTimelineActionOpen, setTripTimelineActionOpen] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);

  const handleTripTimelineActionClose = (status) => {
    setTripTimelineActionOpen(status);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleTripTimelineActionOpen = (status) => {
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    if (status == 'PAYMENT_RECEIVED') {
    } else {
      setTripTimelineActionOpen(true);
    }
  }
  const handleClose = () => {
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setPdfOpen(false);
  }
  const handleViewBill = () => {
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setPdfOpen(true);
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
          {selectedTrip.status != 'PAYMENT_RECEIVED' && <><Button onClick={()=>{handleTripTimelineActionOpen(selectedTrip.status)}} className={classes.actionButton} variant="outlined">{TRIP_ACTIONS[selectedTrip.status]}</Button>
          <div className={classes.sep}></div></>}
          <Button className={classes.viewBill} onClick={handleViewBill} variant="contained">View Bill</Button>
      </Paper>
      {tripTimelineActionOpen && <JourneyTripTimelineAction journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} open={tripTimelineActionOpen} onClose={handleTripTimelineActionClose} />}
      {pdfOpen &&
        <ReportsDialog open={pdfOpen} name={"Trip Bill"} tripIdFromPartySummary={selectedTrip.id} onClose={handleClose} />
      }
    </>
  );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
const JourneyTripActionCardWithRouter = withRouter(JourneyTripActionCard);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JourneyTripActionCardWithRouter);